import Vue from 'vue'

Vue.filter('className', function(value) {
  const className = ['一班', '二班', '三班', '四班', '五班', '六班', '七班', '八班', '九班', '十班']
  return className[Number(value) - 1]
})
Vue.filter('teacherStatus', function(value) {
  const className = ['待定', '在职', '离职']
  return className[Number(value)]
})
Vue.filter('teacherRole', function(value) {
  const className = ['教务处', '班主任', '社团教师']
  return className[Number(value)]
})
Vue.filter('weekName', function(value) {
  const className = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
  return className[Number(value) - 1]
})
Vue.filter('signStatus', function(value) {
  const className = ['待签', '正常', '缺席', '请假']
  return className[Number(value)]
})
Vue.filter('leaveStatus', function(value) {
  const className = ['待审核', '通过', '未通过']
  return className[Number(value)]
})



// WEBPACK FOOTER //
// ./src/util/filter.js